// extracted by mini-css-extract-plugin
export default {"add-client-form":"b3e225","add-client-form__title":"b3ba19","add-client-form__actions":"e18980","checkboxes":"d443ce","checkboxes__item":"e68802","create-part-view":"a09fca"};